import { render, staticRenderFns } from "./AvaliationItemResponseForm.vue?vue&type=template&id=2e90d2ba"
import script from "./AvaliationItemResponseForm.vue?vue&type=script&lang=js"
export * from "./AvaliationItemResponseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports